An array of methods for applying to the position.

If no methods are provided, SEEK's Apply Form will be used to receive candidate applications.
SEEK's Apply Form will emit a `CandidateApplicationCreated` event that points to a `CandidateProfile` object.

This field should only be used to update the `ApplicationMethod.applicationUri` of an existing link out job ad.

We do not recommend changing the application method of a job ad while it is live on the SEEK platform.
Attempting to switch a live job ad between SEEK's Apply Form and linking out to an external apply form may result in unexpected behaviour and complicate applicant tracking.
You may support closing and re-posting the job ad to SEEK with a different application method.

Scheme requirements:

- For the `seekAnz` scheme, this field is limited to a single element.
  Requests with more than 1 element will fail.
